import { render, staticRenderFns } from "./CompanionValuationsTrade.vue?vue&type=template&id=12420a08&"
import script from "./CompanionValuationsTrade.vue?vue&type=script&lang=js&"
export * from "./CompanionValuationsTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports